/* src/app/umbrella-common/components/checklist-question/checklist-question.style.scss */
.question-card {
  border-radius: 4px;
  border: solid 0.5px #0d7c40 !important;
  background-color: #ffffff;
  max-width: 383px !important;
  width: 383px !important;
  box-shadow: none;
  margin-bottom: 20px;
}
.question-card div.divider {
  height: 1px;
  margin: 8px auto;
  border-bottom: 1px solid #cccccc;
}
.question-card#NOTES_FOR_CLIENT_SERVICES-question-card {
  margin-top: 50px;
}
.question-card textarea {
  max-width: 342px;
  min-width: 342px;
  overflow: hidden;
  min-height: 40px;
  height: 40px;
}
.question-card .comment-area {
  margin-top: 5px;
}
.question-card .comment-area.disabled {
  border: none !important;
  color: #585858;
}
.question-card .comment-area#NOTES_FOR_CLIENT_SERVICES-comment-area {
  height: 100px;
}
.question-card .question-header {
  display: flex;
}
.question-card .answer-radio {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.question-card .answer-radio .radio-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
}
.question-card .question {
  margin-top: 0;
  margin-bottom: 10px;
  margin-right: 20px;
  max-width: 299px;
  width: 299px;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  line-height: 22px;
  color: #585858;
}
.question-card .question#NOTES_FOR_CLIENT_SERVICES-question {
  font-size: 18px;
  font-weight: bold;
}
.question-card nb-radio {
  display: inline-block !important;
}
.question-card .client-info {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-top: 10px;
  margin-bottom: 5px;
}
.question-card nb-card-body {
  padding: 20px !important;
}
nb-card.explanation-card {
  margin-bottom: 0 !important;
  border: none !important;
}
nb-card.explanation-card .explanation-body {
  width: 383px;
  height: 118px;
  padding: 20px 26px !important;
  border-radius: 4px;
  border: solid 1px #0044b1;
  background-color: #ffffff;
}
nb-card.explanation-card .explanation-body .label {
  font-size: 15px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.47;
  color: #0044b1;
  max-width: 300px;
  float: left;
}
nb-card.explanation-card .explanation-body .close-icon {
  cursor: pointer;
  vertical-align: middle;
  color: #0044b1 !important;
  float: right;
}
/*# sourceMappingURL=checklist-question.style.css.map */
